import { Typography } from '@mui/material';
import styled from 'styled-components';
import { documentContainerWidth } from '../../utils/constants';
export const DocumentNavigation = styled.div `
  width: ${({ customWidth }) => customWidth ? customWidth : documentContainerWidth};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
  justify-content: ${({ multipledocuments }) => multipledocuments ? 'space-between' : 'center'};
  ${({ usesHTML }) => usesHTML && `width: 100%`}
`;
export const DocumentTitle = styled(Typography) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
